import React from 'react';
import { SlidePage } from '../index';
import { BodyContainer, ProgressBox, ProgressStat } from '../styles';
import { polarColors } from '../constants';

const getColor = value => {
  if (value < 25) {
    return polarColors[4];
  }
  if (value < 50) {
    return polarColors[3];
  }
  if (value < 75) {
    return polarColors[1];
  }
  return polarColors[0];
};

const DysfunctionalBeliefsSecondPage = ({ user, background, number }) => {
  const implicanciasDecision = parseFloat(user['Implicancias de la Decisión']);
  const rolDeOtros = parseFloat(user['Rol de otros significativos']);
  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          <h3>3.2.2. Implicancias de la Decisión</h3>
          <p className='justified'>
            La creencia de que{' '}
            <strong>
              la elección de una carrera es una decisión de por vida y, por lo
              tanto, crucial —comparable a un asunto de vida o muerte— es una
              creencia disfuncional
            </strong>{' '}
            común entre los estudiantes que están a punto de elegir una carrera
            en educación superior. Esta perspectiva puede inducir un gran estrés
            y ansiedad, a menudo llevando a los estudiantes a evitar por
            completo el proceso de toma de decisiones, en lugar de enfrentar el
            miedo y la incertidumbre que pueden acompañarlo.
          </p>
          {/* <p className='justified'>
            Ejemplos: un estudiante puede sentirse tan abrumado por la creencia
            de que su elección de carrera determinará el resto de su vida, que
            puede retrasar la decisión, cambiarse repetidamente de carrera o
            incluso abandonar los estudios
          </p> */}
          <div className='paragraph'>¿Cómo afrontar esta situación?</div>
          <ul className='text-list'>
            <li>- Búsqueda de información y exploración de carreras.</li>
            <li>
              - Estrategias para mejorar tu capacidad de toma de decisiones.
            </li>
            <li>- Estrategias para identificar y afrontar el estrés.</li>
          </ul>
          <div className='progress-info-group'>
            <div className='progress-info'>
              <div className='progress-details-single'>
                <ProgressBox
                  progress={implicanciasDecision}
                  backColor={() => getColor(implicanciasDecision)}
                >
                  <div className='progress'></div>
                </ProgressBox>
                <ProgressStat>{implicanciasDecision}</ProgressStat>
              </div>
            </div>
          </div>
          <br />
          <h3>3.2.3. Creencias sobre el rol de otros en la decisión</h3>
          <p className='justified'>
            Las creencias disfuncionales acerca del papel de otros en la toma de
            decisiones son comunes entre los estudiantes que se encuentran en el
            proceso de elegir una carrera. Estudiantes que puntúan alto en esta
            escala tienden a{' '}
            <strong>
              creer que las personas significativas en su vida, como amigos o
              familiares, son más capaces de evaluar sus habilidades o
              preferencias
            </strong>
            , o incluso saben mejor qué camino deben seguir o qué carrera deben
            elegir. Este tipo de creencias puede dar lugar a una sobrevaloración
            de las opiniones de los demás y a un esfuerzo por satisfacer sus
            expectativas, en lugar de explorar y seguir los propios intereses y
            pasiones.
          </p>
          {/* <p className='justified'>
            Ejemplo: un estudiante puede optar por una carrera en medicina
            porque su familia valora altamente esa profesión, a pesar de que
            personalmente le interese más la literatura.
          </p> */}
          <div className='paragraph'>¿Cómo afrontar esta situación?</div>
          <ul className='text-list'>
            <li>- Reforzar la autonomía.</li>
            <li>- Trabajar en el autoconocimiento.</li>
            <li>- Trabajar sobre manejo de presiones externas.</li>
          </ul>
          <div className='progress-info-group'>
            <div className='progress-info'>
              <div className='progress-details-single'>
                <ProgressBox
                  progress={rolDeOtros}
                  backColor={() => getColor(rolDeOtros)}
                >
                  <div className='progress'></div>
                </ProgressBox>
                <ProgressStat>{rolDeOtros}</ProgressStat>
              </div>
            </div>
          </div>
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default DysfunctionalBeliefsSecondPage;
